import React from 'react';

function ValuePropositionOne() {
  return (
    <svg width={248} height={270} viewBox="0 0 248 270" fill="none">
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M215.292 13.992a.581.581 0 00-.829-.052l-46.914 40.941-66.074 60.374-75.757 37.676c-.311.155-.415.518-.26.829a.57.57 0 00.519.311c.103 0 .155 0 .259-.052l75.86-37.727c.052 0 .104-.052.155-.104l66.074-60.374 46.915-40.94c.207-.208.259-.623.052-.882z"
          fill="#F2F2F2"
        />
        <path
          d="M2.52 11.401H.707V240.72H2.52V11.401zM2.779 240.72H.707v1.814H247.5v-1.814H2.779zM39.078 233.62H13.186c-1.45 0-2.64-1.969-2.64-4.405v-59.752c0-2.436 1.19-4.405 2.64-4.405h25.892c1.45 0 2.64 1.969 2.64 4.405v59.752c0 2.436-1.19 4.405-2.64 4.405zM86.25 233.62H60.36c-1.45 0-2.641-1.969-2.641-4.405V112.768c0-2.436 1.191-4.405 2.64-4.405h25.892c1.45 0 2.64 1.969 2.64 4.405v116.395c0 2.488-1.19 4.457-2.64 4.457zM133.424 233.62h-25.891c-1.45 0-2.641-2.539-2.641-5.649v-76.128c0-3.11 1.191-5.649 2.641-5.649h25.891c1.45 0 2.641 2.539 2.641 5.649v76.128c0 3.11-1.139 5.649-2.641 5.649zM180.65 233.62h-25.891c-1.45.052-2.59-1.814-2.641-4.25V90.225c.051-2.384 1.242-4.302 2.641-4.25h25.891c1.449-.052 2.589 1.814 2.64 4.25v139.197c-.051 2.384-1.242 4.25-2.64 4.198zM227.616 233.62h-25.891c-1.45 0-2.641-1.969-2.641-4.405V50.113c0-2.435 1.191-4.405 2.641-4.405h25.891c1.45 0 2.641 1.97 2.641 4.405v179.05c0 2.488-1.191 4.457-2.641 4.457z"
          fill="#DFDFDF"
        />
        <path
          d="M63.83 266.424c-.208-1.192-3.988-2.228-5.852-.674-.932.778-1.553 2.384-1.036 3.058.208.259-.621.726.156.726 2.537.051 6.939-1.97 6.731-3.11z"
          fill="url(#prefix__paint0_linear)"
        />
        <path
          d="M59.687 266.424l-3.935.207c1.346-2.487-.26-9.224-.26-9.224l4.247.103s-.104 1.97-.363 4.872c-.103.985.052 2.487.311 4.042z"
          fill="#F4A583"
        />
        <path
          d="M60.205 266.372s-4.66-1.088-5.178-.155c-.518.933-.88 3.42 2.07 3.317 2.952-.052 3.367-2.384 3.108-3.162z"
          fill="url(#prefix__paint1_linear)"
        />
        <path
          d="M107.585 266.994c-.103-1.192-3.78-2.539-5.799-1.14-.984.674-1.761 2.228-1.295 2.954.155.259-.673.674.104.726 2.537.259 7.094-1.348 6.99-2.54z"
          fill="url(#prefix__paint2_linear)"
        />
        <path
          d="M102.873 266.787l-3.884.415c1.243-2.54-.776-9.173-.776-9.173l4.246-.104s0 1.969-.104 4.872c-.052.984.207 2.435.518 3.99z"
          fill="#F4A583"
        />
        <path
          d="M103.961 266.631s-4.557-1.451-5.179-.57c-.57.881-1.19 3.317 1.761 3.524 3.055.104 3.625-2.124 3.418-2.954z"
          fill="url(#prefix__paint3_linear)"
        />
        <path
          d="M74.496 140.13c-1.035 17.983-2.537 36.64-4.504 56.022a1226.316 1226.316 0 01-8.234 64.157c-3.832 1.347-7.405 0-7.405 0s-4.505-7.411-7.922-27c-2.227-12.593-2.382-12.438-2.382-14.614-.104-11.09 3.78-14.303 4.505-24.202.673-9.173-2.227-11.919-3.987-22.232-1.347-7.929-1.865-19.486 2.382-34.618 9.165.829 18.382 1.658 27.547 2.487z"
          fill="url(#prefix__paint4_linear)"
        />
        <path
          d="M89.047 130.595a376.104 376.104 0 0113.257 65.557c2.744 24.927 2.692 47.055 1.605 65.297-1.657.467-3.366.933-5.023 1.399-9.735-10.209-13.256-19.589-14.55-26.43-1.968-10.157.983-13.577-1.606-25.03-.57-2.643-1.45-5.494-11.133-24.461-9.27-18.138-11.133-20.781-12.687-27.311-2.226-9.276-1.657-17.568-.776-23.061a4675.035 4675.035 0 0130.913-5.96z"
          fill="url(#prefix__paint5_linear)"
        />
        <path
          d="M135.651 99.967l16.57-38.815c.829-1.918-.259-4.146-2.33-4.665l-30.292-7.358a3.35 3.35 0 00-3.936 2.02l-15.224 37.314c-.776 1.865.259 3.99 2.175 4.56l28.998 8.862c1.554.466 3.314-.363 4.039-1.918z"
          fill="#1C1B3E"
        />
        <path
          d="M133.58 99.294l14.292-36.225c.725-1.814-.259-3.887-2.02-4.353l-26.202-6.893c-1.398-.362-2.848.415-3.417 1.866L103.08 88.514c-.673 1.71.207 3.68 1.864 4.25l25.011 8.292c1.502.518 3.003-.259 3.625-1.762z"
          fill="#fff"
        />
        <path
          d="M144.402 87.426l.518-4.56 2.641-5.027c.362-.674.57-1.451.57-2.229v-4.975l-3.159 7.36s-2.071-1.866-2.9-2.281c-.777-.415-.673 1.192-.104 1.814.622.622-.31 5.441.311 5.96l-.207 3.005 2.33.933z"
          fill="#F4A583"
        />
        <path
          d="M119.184 58.301c-2.485-6.063-7.767-9.535-10.511-11.349-6.525-4.25-10.667-3.472-25.632-5.752-19.936-3.058-22.318-5.908-28.998-3.576C45.24 40.68 40.63 48.662 38.56 52.342c-10.615 18.449 1.812 27.829-1.398 64.623-1.295 15.029-4.66 28.089 3.366 35.759 1.708 1.606 3.573 2.487 7.353 4.197 14.965 6.737 28.376 5.597 36.558 4.768 8.958-.881 13.515-1.399 15.897-4.56 3.78-5.079-.104-11.505-.777-22.647-.466-7.981 1.346-14.355 4.971-27.052 8.441-29.54 19.418-37.52 14.654-49.129z"
          fill="url(#prefix__paint6_linear)"
        />
        <path
          d="M89.1 34.566c2.122-2.591 1.863-6.011 1.76-6.737-.26-3.057-.466-3.524-.932-4.25l-.674-.932-.103-.104c-.466-.466-2.382-1.347-2.848-1.45-1.398-.26-4.92 4.3-7.716 11.711-.155.26-.362.518-.517.777-1.295 1.97-1.45 2.592-1.916 3.162-.88 1.088-2.279 1.295-3.729 1.554-3.314.57-5.178-.725-5.696 0-.57.83.984 3.162 2.59 4.665 2.796 2.643 6.162 3.264 8.284 3.627 2.797.467 6.836 1.14 8.803-1.036 0 0 .622-.674 2.072-3.628 0 0-1.502-.155-3.107-.518-1.088-.26-1.346-.415-1.554-.518-.207-.104-.88-.519-1.139-1.296-.57-1.347.466-2.85.673-3.058.622.052 4.195-.051 5.748-1.969z"
          fill="#F4A583"
        />
        <path
          d="M92.776 21.714c.103 1.918-2.952 4.146-3.78 4.353-.104 0-.622.156-1.191.518-.104.052-.156.104-.26.208-1.087 1.192.415 3.835-.258 4.301-.518.311-1.76-.933-2.123-.622-.31.311.621 1.607.207 1.97-.31.259-.932-.363-1.657-.052-.363.155-.362.362-.984 1.088-.362.363-.777.777-1.036.985-1.346.984-3.78.518-3.935-.208-.052-.207.104-.259.207-.829 0 0 .104-.518 0-1.192-.103-.933-.984-1.97-1.76-3.265-1.399-2.384-1.45-3.887-1.399-4.353 0-.155 0-.31.052-.415.207-1.865 1.243-4.353 2.641-5.493 2.382-1.969 5.644-1.45 8.026-1.036.363.103 7.094 1.295 7.25 4.042z"
          fill="#1C1B3E"
        />
        <path
          d="M86.717 30.265c-.207-.985-1.502-.726-1.916.259-.414.985.104 2.384 1.088 2.591.983.207 1.087-1.555.828-2.85z"
          fill="#F4A583"
        />
        <path
          d="M86.873 28.555l.57 2.228s.517 2.643 1.76 1.866c1.035-.622 1.19-.519 1.242-.467 0 0 .104-.518.156-.933.103.622.259 1.659.103 2.799-.155 1.14-.362 2.384-1.398 3.213-.052.052-1.19.881-2.537.674 0 0-.518-.104-2.382-1.296 0 0 2.848-.622 3.055-.985.518-.984-.673-2.176-.777-4.715 0-1.037.104-1.866.207-2.384z"
          fill="#1C1B3E"
        />
        <path
          d="M145.334 86.545l-4.349-1.865c-2.486 2.539-5.593 4.974-8.234 4.197-3.935-1.192-2.951-8.447-7.767-21.144-5.437-14.407-11.599-18.138-14.706-19.485-1.709-.726-2.952-1.244-4.35-.881-6.628 1.606-8.803 18.863-6.939 31.82 1.036 7.255 3.107 21.558 14.81 28.347 1.657.984 10.822 6.27 19.884 2.073 7.664-3.68 12.428-12.853 11.651-23.062z"
          fill="url(#prefix__paint7_linear)"
        />
        <path
          d="M215.136 18.605a3.315 3.315 0 003.314-3.317 3.315 3.315 0 10-6.628 0 3.316 3.316 0 003.314 3.317zM167.6 58.975a3.315 3.315 0 003.314-3.317 3.315 3.315 0 10-6.628 0 3.316 3.316 0 003.314 3.317zM25.666 156.403a3.315 3.315 0 003.314-3.317 3.315 3.315 0 10-6.628 0 3.315 3.315 0 003.314 3.317z"
          fill="#F2F2F2"
        />
        <path
          d="M217.518 62.447c.57-.31.984-.777 1.295-1.347h2.382c-.466 1.14-1.191 2.073-2.175 2.695-.984.621-2.123.933-3.418.933-1.346 0-2.589-.363-3.624-1.089-1.036-.725-1.813-1.71-2.227-2.954h-1.605v-1.347h1.294c0-.311-.051-.57-.051-.778 0-.207 0-.466.051-.777h-1.294v-1.347h1.605c.414-1.244 1.139-2.229 2.227-2.954 1.035-.726 2.278-1.088 3.624-1.088 1.295 0 2.434.31 3.418.932a5.342 5.342 0 012.175 2.695h-2.382a2.97 2.97 0 00-1.295-1.347c-.569-.311-1.191-.467-1.916-.467-.828 0-1.605.208-2.226.57-.622.415-1.139.933-1.45 1.659h3.728v1.347h-4.091c-.051.26-.051.518-.051.777 0 .26 0 .519.051.778h4.091v1.347h-3.728c.362.726.828 1.296 1.45 1.659.621.414 1.398.57 2.226.57.725 0 1.347-.156 1.916-.467zM170.604 102.766c.569-.311.984-.778 1.294-1.348h2.382c-.466 1.141-1.191 2.073-2.175 2.695-.983.622-2.123.933-3.417.933-1.347 0-2.589-.363-3.625-1.088-1.036-.726-1.812-1.71-2.227-2.954h-1.605v-1.348h1.295c0-.31-.052-.57-.052-.777 0-.207 0-.466.052-.777h-1.295v-1.348h1.605c.415-1.243 1.14-2.228 2.227-2.954 1.036-.725 2.278-1.088 3.625-1.088 1.294 0 2.434.311 3.417.933a5.342 5.342 0 012.175 2.695h-2.382a2.968 2.968 0 00-1.294-1.348c-.57-.31-1.191-.466-1.916-.466-.829 0-1.605.207-2.227.57-.621.415-1.139.933-1.45 1.658h3.729v1.348h-4.091c-.052.259-.052.518-.052.777 0 .26 0 .518.052.777h4.091v1.348h-3.729c.363.725.829 1.295 1.45 1.658.622.415 1.398.57 2.227.57.725 0 1.346-.155 1.916-.466zM123.689 162.933c.57-.311.984-.778 1.295-1.348h2.382c-.466 1.141-1.191 2.073-2.175 2.695-.984.622-2.123.933-3.418.933-1.346 0-2.589-.363-3.624-1.088-1.036-.726-1.813-1.71-2.227-2.954h-1.605v-1.348h1.294c0-.311-.052-.57-.052-.777 0-.207 0-.466.052-.777h-1.294v-1.348h1.605c.414-1.243 1.139-2.228 2.227-2.954 1.035-.725 2.278-1.088 3.624-1.088 1.295 0 2.434.311 3.418.933a5.348 5.348 0 012.175 2.695h-2.382a2.97 2.97 0 00-1.295-1.348c-.569-.311-1.191-.466-1.916-.466-.828 0-1.605.207-2.226.57-.622.415-1.14.933-1.45 1.658h3.728v1.348h-4.091c-.052.259-.052.518-.052.777s0 .518.052.777h4.091v1.348h-3.78c.362.725.828 1.295 1.45 1.658.621.415 1.398.57 2.226.57.777 0 1.399-.155 1.968-.466zM29.239 182.211c.57-.311.984-.777 1.294-1.347h2.383c-.466 1.14-1.191 2.073-2.175 2.695-.984.621-2.123.932-3.418.932-1.346 0-2.589-.362-3.625-1.088-1.035-.725-1.812-1.71-2.226-2.954h-1.606v-1.347h1.295c0-.311-.052-.57-.052-.778 0-.207 0-.466.052-.777h-1.295V176.2h1.606c.414-1.244 1.139-2.229 2.226-2.954 1.036-.726 2.279-1.089 3.625-1.089 1.295 0 2.434.311 3.418.933a5.345 5.345 0 012.175 2.695h-2.382a2.967 2.967 0 00-1.295-1.347c-.57-.311-1.191-.467-1.916-.467-.829 0-1.605.208-2.227.57-.621.415-1.139.933-1.45 1.659h3.729v1.347h-4.09c-.053.259-.053.518-.053.777 0 .26 0 .519.052.778h4.09v1.347h-3.727c.362.726.828 1.296 1.45 1.658.62.415 1.397.571 2.226.571.725 0 1.398-.156 1.916-.467z"
          fill="#fff"
        />
      </g>
      <defs>
        <linearGradient
          id="prefix__paint0_linear"
          x1={65.925}
          y1={263.022}
          x2={57.59}
          y2={268.557}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#343779" />
          <stop offset={0.996} stopColor="#1C1B3E" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={65.299}
          y1={262.08}
          x2={56.965}
          y2={267.615}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#343779" />
          <stop offset={0.996} stopColor="#1C1B3E" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear"
          x1={109.956}
          y1={263.812}
          x2={101.184}
          y2={268.623}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#343779" />
          <stop offset={0.996} stopColor="#1C1B3E" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear"
          x1={109.412}
          y1={262.82}
          x2={100.64}
          y2={267.631}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#343779" />
          <stop offset={0.996} stopColor="#1C1B3E" />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear"
          x1={74.487}
          y1={199.267}
          x2={43.605}
          y2={199.267}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#241134" />
          <stop offset={1} stopColor="#572763" />
        </linearGradient>
        <linearGradient
          id="prefix__paint5_linear"
          x1={12.563}
          y1={211.423}
          x2={97.525}
          y2={196.104}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#241134" />
          <stop offset={0.741} stopColor="#492156" />
          <stop offset={1} stopColor="#572763" />
        </linearGradient>
        <linearGradient
          id="prefix__paint6_linear"
          x1={79.981}
          y1={17.118}
          x2={69.852}
          y2={197.616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB836" />
          <stop offset={0.996} stopColor="#EC5845" />
        </linearGradient>
        <linearGradient
          id="prefix__paint7_linear"
          x1={125.162}
          y1={19.654}
          x2={115.032}
          y2={200.151}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDB836" />
          <stop offset={0.996} stopColor="#EC5845" />
        </linearGradient>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="translate(.5)" d="M0 0h247v270H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ValuePropositionOne;
